import type { ThemeFontTags } from '@sites/site-theme/src/enums/font-tags.enum';
import type { ThemeFontProperties } from '@sites/site-theme/src/enums/font-properties.enum';
import type { ThemeButtonProperties } from '@sites/site-theme/src/enums/button-properties.enum';
import { type ThemeColorNames } from '@sites/site-theme/src/enums/color-names.enum';

import {
    THEME_BUTTONS_VARIABLES,
    THEME_COLORS_VARIABLES,
    THEME_FONTS_VARIABLES,
} from '@sites/site-theme/src/config/css-variables';

const varString = (value: string): string => `var(${value})`;

export function themeColorCss(property: ThemeColorNames | string): string {
    if (!property) {
        return '';
    }

    if (!THEME_COLORS_VARIABLES[property]) {
        return property;
    }

    return varString(THEME_COLORS_VARIABLES[property]);
}

export function themePrimaryButtonCss(property: ThemeButtonProperties, index: number = 0): string {
    const variable = THEME_BUTTONS_VARIABLES.primary![property];

    if (Array.isArray(variable)) {
        return varString(variable[index]!);
    }

    return varString(variable);
}

export function themeSecondaryButtonCss(property: ThemeButtonProperties, index: number = 0): string {
    const variable = THEME_BUTTONS_VARIABLES.secondary![property];

    if (Array.isArray(variable)) {
        return varString(variable[index]!);
    }

    return varString(variable);
}

export function themeFontCss(tag: ThemeFontTags, property: ThemeFontProperties): string {
    return varString(THEME_FONTS_VARIABLES[tag][property]);
}
